import { convertDateToTimezone } from '@/lib/timezone';
import { DateSelectedValue } from '@/utils/constant';
import clsx from 'clsx';
import {
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import { ReactNode } from 'react';
import { TZDate } from 'react-day-picker';

const ButtonSelect = (props: {
  value: DateSelectedValue;
  timezone: string;
  onChange: (startDate: TZDate, endDate: TZDate) => void;
}) => {
  const currentDate = convertDateToTimezone(new Date(), props.timezone);
  const options: {
    value: DateSelectedValue;
    label: ReactNode;
    inActiveLabel?: ReactNode;
    startDate: TZDate;
    endDate: TZDate;
  }[] = [
    {
      value: 'Day',
      label: 'Day',
      startDate: currentDate,
      endDate: currentDate,
    },
    {
      value: 'Week',
      label: 'Week',
      startDate: startOfWeek(currentDate, { weekStartsOn: 1 }),
      endDate: endOfWeek(currentDate, { weekStartsOn: 1 }),
    },
    {
      value: 'Month',
      label: 'Month',
      startDate: startOfMonth(currentDate),
      endDate: endOfMonth(currentDate),
    },
    {
      value: 'Year',
      label: 'Year',
      startDate: startOfYear(currentDate),
      endDate: endOfYear(currentDate),
    },
  ];
  return (
    <div className="flex w-full items-center justify-between gap-2">
      {options.map((option) => (
        <button
          key={option.value}
          className={clsx(
            'h-12 flex-1 rounded-[1.875rem] border border-primary-text py-[0.625rem] text-primary-text',
            option.value === props.value
              ? 'bg-primary text-white'
              : 'bg-[#F1F4FC]',
          )}
          onClick={() => props.onChange(option.startDate, option.endDate)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonSelect;
